import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { toast } from "react-toastify";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import { commonDeleteApi } from "../../redux/reducers/deleteApiSlice";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { delete_tme_approval_manager } from "../../data/ApiEndpoints";
import { fetchTMEApprovalManagerData } from "../../redux/prospect-reducers/prospectSlice";
import { convertStraight } from "../common-data/Converts";
import SearchNButtons from "../common-components/SearchNButtons";
import TMEApprovalManagerForm from "./TMEApprovalManagerForm";

const TMEApprovalManager = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const {
    tmeApprovalManagerLoading,
    tmeApprovalManager,
    tmeApprovalManagerError,
  } = useSelector((state) => state.prospects);
  const { loading } = useSelector((state) => state.delApi);

  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);
  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniClickValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [clickValues, setClickValues] = useState(iniClickValues);

  function onCloseModal() {
    setClickValues(iniClickValues);
  }

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getApprovalManagers(filters) {
    dispatch(
      fetchTMEApprovalManagerData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: delete_tme_approval_manager,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            getApprovalManagers(filters);
            toast.success(response?.message || "Deleted successfully!");
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Deleted SuccessFully");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete this!`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    getApprovalManagers(filters);
  }, [filters]);

  useEffect(() => {
    if (
      tmeApprovalManager?.status &&
      tmeApprovalManager?.data &&
      !tmeApprovalManagerLoading &&
      !tmeApprovalManagerError
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: tmeApprovalManager.data,
        pagination:
          tmeApprovalManager?.pagination?.length > 0
            ? tmeApprovalManager.pagination
            : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [tmeApprovalManager, tmeApprovalManagerLoading, tmeApprovalManagerError]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "user_id",
      text: "approval manager",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.user_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth90 withPadding borderRdius8"
            style={{
              background: row?.status === "active" ? "#379C00" : "#C80000",
              color: "#fff",
            }}
          >
            {row?.status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "last_updated",
      text: "last updated",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.last_updated ? convertStraight(row?.last_updated) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            disabled={false}
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "edit",
              }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16"
              style={{
                color: "#CD0909",
              }}
            >
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>

          <button
            className="actionBtn icon delete"
            disabled={loading}
            style={{
              cursor: loading ? "not-allowed" : "pointer",
            }}
            onClick={(e) => {
              const payload = {
                uid: row?.uid,
              };
              handleDelete(payload);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-trash3-fill"
              viewBox="0 0 16 16"
              style={{
                color:
                  row?.lead_status?.toLowerCase() === "closed" ||
                  row?.lead_status?.toLowerCase() === "converted"
                    ? "gray"
                    : "#CD0909",
              }}
            >
              <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Handle Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            clickValues.cardName === "edit" || clickValues.cardName === "add"
              ? "mod-width-50p"
              : ""
          }`}
        >
          <ModalHeadAndClose
            title={`${clickValues.cardName?.replace(
              /_/g,
              " "
            )} Approval Manager`}
            onClose={onCloseModal}
          />

          <TMEApprovalManagerForm
            userInfoData={userInfoData}
            closeModal={onCloseModal}
            callFunction={() => getApprovalManagers(filters)}
            rowData={clickValues.rowData}
            isEdit={clickValues.cardName === "edit"}
          />
        </div>
      </Modal>

      <SearchNButtons
        btnText="+ Add New"
        onClickAdd={() =>
          setClickValues((prevs) => ({
            ...prevs,
            isModOpen: true,
            cardName: "add",
          }))
        }
        filters={allFilters}
        setFilters={setAllFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt30">
        {tmeApprovalManagerLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default TMEApprovalManager;
